export default "__VITE_ASSET__DS5hQE06__"